// // RouteContext.js
// import React, { createContext, useContext, useEffect, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";

// const RouteContext = createContext();

// export function RouteProvider({ children }) {
//   const location = useLocation();
//   const [prevRoute, setPrevRoute] = useState(null);
//   const lastLocationRef = useRef(location.pathname);

//   useEffect(() => {
//     // update prevRoute to the last location before changing
//     setPrevRoute(lastLocationRef.current);
//     // then update the ref to the new location
//     lastLocationRef.current = location.pathname;
//   }, [location]);

//   return (
//     <RouteContext.Provider value={{ prevRoute }}>
//       {children}
//     </RouteContext.Provider>
//   );
// }

// export function usePrevRoute() {
//   return useContext(RouteContext).prevRoute;
// }

import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { JoyrideProvider } from "../../routes/JoyrideProvide"; // adjust import path

const RouteContext = createContext();

export function RouteProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate(); // ✅ NOW SAFE
  const [prevRoute, setPrevRoute] = useState(null);
  const lastLocationRef = useRef(location.pathname);

  useEffect(() => {
    // update prevRoute to the last location before changing
    setPrevRoute(lastLocationRef.current);
    // then update the ref to the new location
    lastLocationRef.current = location.pathname;
  }, [location]);

  // ✅ THIS is what Joyride will call
  const handleTourRouteChange = (route) => {
    if (route && route !== location.pathname) {
      console.log("Tour navigating to:", route);
      navigate(route);
    }
  };

  return (
    <RouteContext.Provider value={{ prevRoute }}>
      {/* 👇 JoyrideProvider is now INSIDE Router context */}
      <JoyrideProvider onRouteChange={handleTourRouteChange}>
        {children}
      </JoyrideProvider>
    </RouteContext.Provider>
  );
}

export function usePrevRoute() {
  return useContext(RouteContext).prevRoute;
}
